<template>
  <v-container :fluid="true" class="ma-0 pa-0 bg-light-blue">
    <Mails
        v-if="$route.name === names.MAIL.PAGE"
    />
    <router-view v-else />
  </v-container>
</template>

<script>
import { defineComponent } from 'vue'
import Mails from "@/modules/personal_account/mails/pages/Mails.vue"
import names from "@/modules/personal_account/routers/names"

export default defineComponent({
  name: "MailsBase",
  computed: {
    names () {
      return names
    }
  },
  components: { Mails }
})
</script>

<style scoped lang="scss">

</style>
